export enum StandardStorkRoles {
    DEFAULT = 'stork:default_role',
    EDITOR = 'stork:editor',
    ADMIN = 'stork_admin',
}
